import {defineMessages} from 'react-intl'

export const TRUSTPILOT_LABELS = defineMessages({
  seeOtherReviews: {
    id: 'trustpilot.seeOtherReviews',
    defaultMessage: 'See what other travelers say'
  },
  seeWhatTravelersSay: {
    id: 'trustpilot.seeWhatTravelersSay',
    defaultMessage: 'See what travelers say about Vio'
  },
  travelersTrustVio: {
    id: 'trustpilot.travelersTrustVio',
    defaultMessage: 'Thousands of travelers trust Vio'
  },
  tensOfThousandsTrustVio: {
    id: 'trustpilot.tensOfThousandsTrustVio',
    defaultMessage: 'Tens of thousands of travelers trust Vio'
  },
  viewAllReviews: {
    id: 'trustpilot.viewAllReviews',
    defaultMessage: 'View all reviews on Trustpilot'
  }
})
